export const DCTW26_CODE = 'DCTW26';

export function isDctw26Code(code: string): boolean {
  return code.trim().toUpperCase() === DCTW26_CODE;
}

/**
 * DCTW26 may show Applied only for Pro on monthly billing.
 * Annual billing, or any non-Pro tier (including Starter), must not.
 */
export function dctw26BlocksApplied(
  code: string,
  billingCycle: 'monthly' | 'annual',
  tierId?: string
): boolean {
  if (!isDctw26Code(code)) {
    return false;
  }
  if (billingCycle === 'annual') {
    return true;
  }
  if (tierId !== undefined && tierId !== 'pro') {
    return true;
  }
  return false;
}
